var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M7.696 13.504L11.2 10H9.5a.5.5 0 0 1 0-1H13v3.5a.5.5 0 1 1-1 0v-1.886l-3.597 3.597a.5.5 0 0 1-.707-.707zM5 10V7a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h4.5a.5.5 0 1 1 0 1H10v4H6v4H2v3.5a.5.5 0 1 1-1 0V11a1 1 0 0 1 1-1h3z" })
  );
});